<template>
      <iframe title="PDF" width="100%" :src="'/pdfjs/web/viewer.html?file=' + srcUrl" />
  </template>
  
  <script>
  export default {
    name: "PDFJSViewer",
    props: ["srcUrl"],
    
  }
  </script>